import EntityPage from '../EntityPage/EntityPage';

const AssetIndex = () => {
    return <EntityPage entityType="AssetIndex" />;
};

export default AssetIndex;
